import { Component } from '@theme/component';
import { StandardEvents } from '@shopify/events';
/**
 * Component that reflects the currently selected variant's SKU into the DOM.
 *
 * Listens for `StandardEvents.productSelect` from a ProductInformation / QuickAdd
 * / product-card ancestor and updates its `<product-sku-component>` element.
 */ class ProductSkuComponent extends Component {
  requiredRefs = ['skuContainer', 'sku'];
  connectedCallback() {
    super.connectedCallback();
    const target = this.closest(
      '[id*="ProductInformation-"], [id*="QuickAdd-"], product-card',
    );
    if (!target) return;
    target.addEventListener(
      StandardEvents.productSelect,
      this.#handleProductSelect,
    );
  }
  disconnectedCallback() {
    super.disconnectedCallback();
    const target = this.closest(
      '[id*="ProductInformation-"], [id*="QuickAdd-"], product-card',
    );
    if (!target) return;
    target.removeEventListener(
      StandardEvents.productSelect,
      this.#handleProductSelect,
    );
  }
  /**
   * Hide the SKU display and clear any stale text.
   *
   * @returns {void}
   */ hideSku() {
    this.style.display = 'none';
    this.refs.sku.textContent = '';
  }
  #handleProductSelect = (event) => {
    event.promise
      .then(({ detail: detail }) => {
        if (!detail) return;
        const { newProduct: newProduct, resource: resource } = detail;
        if (newProduct) {
          this.dataset.productId = newProduct.id;
        } else if (
          detail.productId &&
          detail.productId !== this.dataset.productId
        ) {
          return;
        }
        const variantSku = resource && resource.sku;
        if (!variantSku) {
          this.hideSku();
          return;
        }
        this.style.display = 'block';
        this.refs.sku.textContent = variantSku;
      })
      .catch((error) => {
        if (error?.name !== 'AbortError')
          console.warn('[product-sku] Event promise rejected:', error);
      });
  };
}
